import { useQuery } from '@tanstack/react-query';
import services from 'services/services';

/**
 * Query hook for fetching custom data columns (person data keys).
 *
 * @param {Object} [options] - Additional useQuery options
 * @returns {Object} useQuery result object
 */
export function useCustomDataColumnsQuery(options = {}) {
    return useQuery({
        queryKey: ['custom-data-columns'],
        queryFn: () => services.getCustomDataColumnsXHR(),
        ...options
    });
}
